import { render, staticRenderFns } from "./notFoundPage.vue?vue&type=template&id=2acd7ec4&scoped=true&"
import script from "./notFoundPage.vue?vue&type=script&lang=js&"
export * from "./notFoundPage.vue?vue&type=script&lang=js&"
import style0 from "./notFoundPage.vue?vue&type=style&index=0&id=2acd7ec4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2acd7ec4",
  null
  
)

export default component.exports